import { render, staticRenderFns } from "./detail-retur.vue?vue&type=template&id=a6d281e6"
import script from "./detail-retur.vue?vue&type=script&lang=js"
export * from "./detail-retur.vue?vue&type=script&lang=js"
import style0 from "./detail-retur.vue?vue&type=style&index=0&id=a6d281e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports